export default function getResource(label, vars = []) {
    const resources = {
        addAllToBasket: 'Tout ajouter au panier',
        change: 'Modifier',
        currentProduct: 'Article actuel',
        estimatedPrice: 'Total price:',
        frequentlyBoughtTogether: 'Frequently Bought Together'
    };
    return resources[label];
}
